import { createContext, useContext, useState } from "react"

const GlobalContext = createContext({})

export default function useGlobalContext() {
  return useContext(GlobalContext)
}

export function GlobalContextProvider({ children }) {
  const [cursorType, setCursorType] = useState("")
  const [small, setSmall] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  const [openCart, setOpenCart] = useState(false)
  const [openWishList, setOpenWishList] = useState(false)

  function changeCursor(type) {
    setCursorType(type)
  }

  return (
    <GlobalContext.Provider
      value={{
        cursorType,
        changeCursor,
        small,
        setSmall,
        showMenu,
        setShowMenu,
        openCart,
        setOpenCart,
        setOpenWishList,
        openWishList,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}
